import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
var prefix = 'sfx-react-ui';
export var themes = {
  light: 'light',
  dark: 'dark'
};
var defaultValue = {
  prefix: prefix,
  theme: themes.dark,
  toggleTheme: function toggleTheme() {// change theme.
  }
};
var runtimeTheme = {
  theme: defaultValue.theme
};

var changeTheme = function changeTheme(newTheme) {
  if (newTheme) {
    runtimeTheme.theme = newTheme;
  } else {
    runtimeTheme.theme = defaultValue.theme;
  }
};

export var ThemeContext = /*#__PURE__*/React.createContext(defaultValue);
export var ThemeConsumer = ThemeContext.Consumer;

var ThemeProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ThemeProvider, _React$Component);

  var _super = _createSuper(ThemeProvider);

  function ThemeProvider() {
    _classCallCheck(this, ThemeProvider);

    return _super.apply(this, arguments);
  }

  _createClass(ThemeProvider, [{
    key: "render",
    value: function render() {
      var _this$props$theme = this.props.theme,
          theme = _this$props$theme === void 0 ? 'dark' : _this$props$theme;

      var config = _objectSpread(_objectSpread(_objectSpread({}, defaultValue), this.props), {}, {
        theme: theme
      });

      changeTheme(theme);
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: config
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-theme"),
        "data-theme": theme
      }, this.props.children));
    }
  }]);

  return ThemeProvider;
}(React.Component);

export default ThemeProvider;
export var getTheme = function getTheme() {
  return runtimeTheme;
};